

class SearchCounter {
  constructor() {
    this.searchCounter = document.querySelector('.wp-search-counter__count');
    this.searchResults = document.querySelector('.wp-search__results');

    if(this.searchCounter && this.searchResults){
      this.bindCounter();
    }
  }

  bindCounter(){
    this.searchCounter.innerHTML = this.searchResults.childElementCount;
  }
}
export default SearchCounter;
